import styled from "styled-components";
import Picker from "react-datetime-picker/dist/entry.nostyle";
import dayjs from "dayjs";
import { useRef, MouseEvent } from "react";
// import { CSSProperties } from "react";

interface Props {
	onChange: any;
	dateTime: any;
	dark?: boolean;
	borderedLeft?: boolean;
	borderedRight?: boolean;
	format?: string;
	hideClearIcon?: boolean;
	hideCalendarIcon?: boolean;
	withoutPaddings?: boolean;
	low?: boolean;
	leadingCalendarIcon?: boolean;
}

interface ContainerProps {
	isLow?: boolean;
}

const Container = styled.div<ContainerProps>`
	width: 100%;
	height: ${(props) => (props.isLow ? "48px" : "60px")};
	background: transparent;
	display: flex;
	align-items: center;
`;



const DateTimePicker = (props: Props): JSX.Element => {
		const {
			onChange,
			dateTime,
			dark,
			borderedLeft,
			borderedRight,
			format,
			hideClearIcon,
			hideCalendarIcon,
			withoutPaddings,
			low,
			leadingCalendarIcon,
		} = props;

		const pickerRef = useRef<any>(null);

			const pickerProps = {} as {
				value?: Date;
				clearIcon?: any;
				calendarIcon?: any;
			};

			const openCalendar = (event: MouseEvent<HTMLDivElement>) => {
				const target = event.target as HTMLElement | null;
				if (target?.closest("select")) {
					return;
				}
				if (pickerRef.current?.openCalendar) {
					pickerRef.current.openCalendar();
				}
			};



	if (dateTime) {
		pickerProps.value = dayjs(dateTime).toDate();
	}

	if (hideClearIcon) {
		pickerProps.clearIcon = null;
	}

	if (hideCalendarIcon) {
		pickerProps.calendarIcon = null;
	}

		return (
			<Container isLow={Boolean(low)}>
					<Picker
						ref={pickerRef}
						className={[
							`react-datetime-picker--${dark ? "dark" : "light"}`,
							borderedLeft ? "react-datetime-picker--borderedLeft" : null,
							borderedRight ? "react-datetime-picker--borderedRight" : null,
							withoutPaddings ? "react-datetime-picker--withoutPaddings" : null,
							low ? "react-datetime-picker--low" : null,
							leadingCalendarIcon ? "react-datetime-picker--leadingCalendarIcon" : null,
						].join(" ")}
						onClick={openCalendar}
						onChange={onChange}
						showLeadingZeros
						format={format || "dd/MM/y"}

					{...pickerProps}
				/>
		</Container>
	);
};

export default DateTimePicker;
